const processVals = {};

export const ENV = {
  DEMO: "demo",
  STG: "staging",
  PROD: "production",
  DEV: "development",
};

export const PLATFORM_USER_ROLE = {
  DATA_APPROVER: "Data Approver",
  DATA_MANAGER: "Data Manager",
  DATA_SUBMITTER: "Data Submitter",
  DATA_READER: "Data Reader",
  DATA_REVIEWER: "Data Reviewer",
};

export const HUB_FEATURE_FLAG = "HUB_VIEW";

export const PLACEHOLDER_ORG_ID = "-1";

export default processVals;
